<template>
    <div class="main-container">
        <div class="global-redirects-page">
            <div class="global-redirects-page__left">
                <main-menu></main-menu>
            </div>
            <div class="global-redirects-page__right">
                <h2 class="main-title bottom-row">Global Redirects management</h2>
                <Loader v-if="isScriptsLoadInProgress"></Loader>
                <div class="main-form">
                    <div class="form">
                        <div>
                            <div class="redirect-box" style="white-space: nowrap; padding-top: 2px" v-for="(rd, index) in redirects" v-bind:key="index">
                                <div class="multiple-inputs-wrap">
                                    <div class="form__input-box">
                                        <label>
                                            <input type="text" class="form__input" name="from" placeholder="from"  v-model="rd.from" >
                                        </label>
                                    </div>
                                    <div class="form__input-box">
                                        <label>
                                            <input type="text" class="form__input" name="to" placeholder="to" v-model="rd.to" >
                                        </label>
                                    </div>
                                    <div class="form__input-box form__input-box--small">
                                        <label>
                                            <select class="form__select" v-model="rd.type">
                                                <option :value="301">301</option>
                                                <option :value="302">302</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div class="form__input-box form__input-box--small">
                                        <label>
                                            <select class="form__select" v-model="rd.message">
                                                <option value="REDIRECT_MSG">REDIRECT_MSG</option>
                                            </select>
                                        </label>
                                    </div>
                                    <div class="global-redirects-page__right-btns" >
                                        <v-btn outlined color="indigo"
                                                @click="removeRow(rd.key)">
                                            <span>delete</span>
                                        </v-btn >
                                    </div>
                                </div>
                                <div style="padding-top: 5px;">
                                  <v-expansion-panels>
                                    <v-expansion-panel >
                                      <v-expansion-panel-header>excluded domains ({{ rd.exclude ? rd.exclude.length : 0 }})</v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <exclude-domains
                                          :domains="rd.exclude"
                                          @update="updateExcludedDomains($event, index)"
                                        />
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </div>
                            </div>
                        </div>
                        <div class="top-row1" style="padding-bottom: 70px">
                            <div v-if="errorMsgs.length > 0"><span style="color: red;">Errors:</span>
                                <div v-for="err in errorMsgs" v-bind:key="err">{{err}}</div>
                            </div>
                            <div class="btns-row__right-btns" style="padding-top: 10px">
                                <v-btn v-if="$checkRoles(['Administrator'])"
                                       outlined color="red" large
                                        @click="saveAllChanges()">
                                    <Loader v-if="isScriptsLoadInProgress"></Loader>
                                    <span v-else>Save Changes</span>
                                </v-btn>
                            </div>
                        </div>
                        <h2 class="main-title bottom-row">Add new row</h2>
                        <div >
                            <div class="multiple-inputs-wrap" style="white-space: nowrap">
                                <div class="form__input-box">
                                    <label>
                                        <input type="text" class="form__input" placeholder="from" name="from" v-model="redirect.from" v-input-trim >
                                        <div style="color: red">{{fromErrorMessage}}</div>
                                    </label>
                                </div>
                                <div class="form__input-box">
                                    <label>
                                        <input type="text" class="form__input" placeholder="to" name="to" v-model="redirect.to" v-input-trim >
                                        <div style="color: red">{{toErrorMessage}}</div>
                                    </label>
                                </div>
                                <div class="form__input-box form__input-box--small">
                                    <label>
                                        <select class="form__select" v-model="redirect.type">
                                            <option value="301">301</option>
                                            <option value="302">302</option>
                                        </select>
                                    </label>
                                </div>
                                <div class="form__input-box form__input-box--small">
                                    <label>
                                        <select class="form__select" v-model="redirect.message">
                                            <option value="REDIRECT_MSG">REDIRECT_MSG</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                            <div class="multiple-inputs-wrap" style="padding-top: 5px">
                                <div class="form__input-box">
                                  <label>Exclude domains:</label>
                                  <exclude-domains
                                    :domains="redirect.exclude"
                                    @update="updateExcludedDomains($event)"
                                  />
                                </div>
                            </div>
                            <div class="multiple-inputs-wrap" style="padding-top: 10px">
                                <div class="global-redirects-page__right-btns" >
                                    <v-btn outlined color="indigo"
                                            @click="addNewRow()">
                                        <span>add new row</span>
                                    </v-btn >
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <InfoModal
                v-if="scriptIsSaved"
                :msg="infoModalMessage"
                :onCloseModal="closeInfoModal"
        ></InfoModal>
    </div>
</template>

<script>
  import Loader from '../Loader/Loader.vue'
  import InfoModal from '../InfoModal/InfoModal.vue'
  import config from '../../config'
  import MainMenu from '../MainMenu/MainMenu.vue'
  import ExcludeDomains from './ExcludeDomains.vue'
  import {validateRedirects} from '../../utils/validation'
  import { ClearCacheService } from '../../services/ClearCacheService'

  export default {
    components: { MainMenu, Loader, InfoModal, ExcludeDomains },
    name: 'GlobalRedirectsPage',
    props: [],
    data () {
      return {
        scriptIsSaved: false, // arena edited success flag
        isScriptsLoadInProgress: false,
        infoModalMessage: '',
        redirects: [],
        arena: undefined,
        redirect: {
          from: '',
          to: '',
          type: '',
          message: '',
          exclude: []
        },
        excludeDomain: '',
        fromErrorMessage: '',
        toErrorMessage: '',
        errorMsgs: []
      }
    },
    created: function () {
      this.initForm()
    },
    watch: {

    },
    computed: {

    },
    methods: {
      initForm: function () {
        this.isScriptsLoadInProgress = true
        let arenaPromise = this.$http.get(`${config.apiUrl}/arena/globalredirects/get`)
        Promise.all([arenaPromise])
          .then(([arenaPromise]) => {
            this.redirects = arenaPromise.body
            if (this.redirects) {
              this.redirects.forEach((item, index) => {
                item.key = index
              })
            }
            this.isScriptsLoadInProgress = false
          }, error => {
            console.log(error)
            this.isScriptsLoadInProgress = false
          })
      },
      addNewDomain: function (rd) {
        this.errorMsgs = []
        if (this.excludeDomain === '') {
          this.errorMsgs.push('Excluded domain can not be empty')
        }
        if (this.excludeDomain.indexOf(' ') >= 0) {
          this.errorMsgs.push('Excluded domain can not contains white spaces')
        }
        if (this.excludeDomain.indexOf('/') >= 0 || this.excludeDomain.indexOf('http:') >= 0 || this.excludeDomain.indexOf('https:') >= 0) {
          this.errorMsgs.push('Excluded domain can not contains any symbols like / or protocols')
        }
        if (!/^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(this.excludeDomain)) {
          this.errorMsgs.push('Invalid domain name')
        }
        if (this.excludeDomain !== '' && this.errorMsgs.length === 0) {
          this.redirect.exclude.push(this.excludeDomain)
          this.excludeDomain = ''
        }
      },
      addNewRow: function () {
        this.fromErrorMessage = this.toErrorMessage = ''
        this.errorMsgs = validateRedirects([this.redirect], this.redirects)
        if (this.errorMsgs.length === 0) {
          this.errorMsgs = []
          this.redirects.push(this.redirect)
          this.redirects.forEach((item, index) => {
            item.key = index
          })
          this.redirect = {}
        }
      },
      removeRow: function (key) {
        let filtered = []
        this.redirects.forEach(rd => {
          if (rd.key !== key) {
            filtered.push(rd)
          }
        })
        this.redirects = filtered
      },
      saveAllChanges: function () {
        this.removeEndSlash()
        this.errorMsgs = validateRedirects(this.redirects)
        if (this.errorMsgs.length === 0) {
          this.errorMsgs = []
          const url = `${config.apiUrl}/arena/globalredirects/save`
          const headers = {
            headers: {'Content-Type': 'application/json'}
          }
          this.$http.post(url, this.redirects, headers)
            .then(response => {
              this.showInfoModal('Changes are saved.')
              ClearCacheService.clearCacheRedirects()
            }, error => {
              console.log(error)
            })
        }
      },
      closeInfoModal: function () {
        this.scriptIsSaved = false
      },
      showInfoModal: function (message) {
        this.infoModalMessage = message
        this.scriptIsSaved = true
      },
      id: function (name, index) {
        return name + '-' + index
      },
      removeEndSlash: function () {
        this.redirects.forEach(rd => {
          if (rd.from.endsWith('/')) {
            rd.from = rd.from.substring(0, rd.from.length - 1)
          }
          if (rd.to.endsWith('/')) {
            rd.to = rd.to.substring(0, rd.to.length - 1)
          }
        })
      },
      chipClickClose: function (rd, domain) {
        rd.exclude = rd.exclude.filter(val => val !== domain)
      },
      updateExcludedDomains({ domains, errorMsgs }, redirectIndex) {
        if (errorMsgs.length === 0 && typeof redirectIndex === 'number') {
          this.redirects[redirectIndex].exclude = domains
        } else if (errorMsgs.length === 0) {
          this.redirect.exclude = domains
        }

        this.errorMsgs = errorMsgs
      }
    }
  }
</script>

<style scoped lang="scss" src="./GlobalRedirectsPage.scss"></style>
